import { AddReadFileExpenseType } from "../../../domain/useages/expense-dashboard/add-read-file-expense";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpPostClient } from "../../protocols/http/http-post-client";

export class RemoteAddReadFileExpense
  implements AddReadFileExpenseType
{
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpPostClient
  ) {}

  async add(params: AddReadFileExpenseType.Params): Promise<any> {
    const httpResponse = await this.httpPostClient.post({
      url: this.url,
      body: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
      return httpResponse.data;
  }
}
